import React from 'react';
import { Tab, Nav } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import UtilisateursTab from '../../components/Tabs/AdminTabs/UtilisateursTab';
import GroupesTab from '../../components/Tabs/AdminTabs/GroupesTab';
import PermissionsTab from '../../components/Tabs/AdminTabs/PermissionsTab';
import ParametresTab from '../../components/Tabs/AdminTabs/ParametresTab';
import ChampsTab from '../../components/Tabs/AdminTabs/ChampsTab';
import API from '../APIKeys/API';

const Admin = ({ titre }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') || 'utilisateurs';

    const handleTabSelect = (key) => {
        setSearchParams({ tab: key });
    };

    return (
        <>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">{titre}</h1>
            </div>

            <div className="mt-3 px-4">
                <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                    <Nav variant="tabs">
                        <Nav.Item>
                            <Nav.Link eventKey="utilisateurs">Utilisateurs</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="groupes">Groupes</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="permissions">Permissions</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="champs">Champs personnalisés</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="parametres">Paramètres</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="apikeys">Clés API</Nav.Link>
                        </Nav.Item>
                    </Nav>

                    <Tab.Content className="mt-4">
                        <Tab.Pane eventKey="utilisateurs">
                            <UtilisateursTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="groupes">
                            <GroupesTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="permissions">
                            <PermissionsTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="champs">
                            <ChampsTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="parametres">
                            <ParametresTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="apikeys">
                            <API />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </div>
        </>
    );
};

export default Admin;